"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plusOneComponent = exports.PlusOneComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var PlusOneForm_1 = require("Views/Partials/Components/PlusOneForm");
var types_1 = require("Views/Partials/Components/PlusOneForm/types");
var PlusOneSupportFormConfig_1 = require("./PlusOneSupportFormConfig");
var PlusOneComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlusOneComponent, _super);
    function PlusOneComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.plus-one-form';
        _this.convertData = function (inputLabels, errorInputMessage, hint) {
            var convertedData = [];
            Object.keys(inputLabels).map(function (input) {
                return convertedData.push(tslib_1.__assign(tslib_1.__assign({}, PlusOneSupportFormConfig_1.inputData[input]), { label: inputLabels[input], errorMessage: errorInputMessage, hint: hint }));
            });
            return convertedData;
        };
        return _this;
    }
    PlusOneComponent.prototype.OnInit = function () {
        var _this = this;
        this.el.forEach(function (el) {
            _this.InitForm(el);
        });
    };
    PlusOneComponent.prototype.InitForm = function (selector) {
        var _a, _b;
        var title = app_1.AttrService.data(selector, 'title');
        var apiUrl = app_1.AttrService.data(selector, 'post-url');
        var pageId = app_1.AttrService.data(selector, 'page');
        var control = app_1.AttrService.data(selector, 'control');
        var formType = app_1.AttrService.data(selector, 'form-type');
        var culture = app_1.AttrService.data(selector, 'culture');
        var reCaptchaSiteKey = app_1.AttrService.data(selector, 'recaptcha-key');
        var successMessageTitle = app_1.AttrService.data(selector, 'success-message-title');
        var successMessage = app_1.AttrService.data(selector, 'success-message');
        var errorMessage = app_1.AttrService.data(selector, 'error-message');
        var userConsentText = app_1.AttrService.data(selector, 'user-consent-text');
        var userConsentValidationText = app_1.AttrService.data(selector, 'user-consent-validation-message');
        var userConsentUrlAndText = app_1.AttrService.data(selector, 'user-consent-url-message');
        var attachmentInfo = app_1.AttrService.data(selector, 'attachment-info');
        var instructionSubmit = app_1.AttrService.data(selector, 'instruction-submit');
        var instructionMandatory = app_1.AttrService.data(selector, 'instruction-mandatory');
        var instructionEmail = app_1.AttrService.data(selector, 'instruction-email');
        var hint = app_1.AttrService.data(selector, 'input-hint-message');
        var errorInputMessage = app_1.AttrService.data(selector, 'input-validation-message');
        var inputFileErrorMessage = app_1.AttrService.data(selector, 'input-file-validation-message');
        var emailLabel = app_1.AttrService.data(selector, 'email-label');
        var productLabel = app_1.AttrService.data(selector, 'product-label');
        var eidLabel = app_1.AttrService.data(selector, 'eid-label');
        var subjectLabel = app_1.AttrService.data(selector, 'subject-label');
        var descriptionLabel = app_1.AttrService.data(selector, 'description-label');
        var bypassRecaptchaKey = app_1.AttrService.data(selector, 'bypass-recaptcha-key');
        var inputLabelsLeft = (_a = {},
            _a[types_1.InputName.EMAIL] = emailLabel,
            _a[types_1.InputName.PRODUCT] = productLabel,
            _a[types_1.InputName.EID] = eidLabel,
            _a[types_1.InputName.CHECKBOX] = userConsentUrlAndText,
            _a);
        var inputLabelsRight = (_b = {},
            _b[types_1.InputName.SUBJECT] = subjectLabel,
            _b[types_1.InputName.DESCRIPTION] = descriptionLabel,
            _b);
        var formItemsLeft = this.convertData(inputLabelsLeft, errorInputMessage, hint);
        var formItemsRight = this.convertData(inputLabelsRight, errorInputMessage, hint);
        var formMessages = {
            successMessageTitle: successMessageTitle,
            successMessage: successMessage,
            errorMessage: errorMessage,
            userConsentText: userConsentText,
            userConsentValidationText: userConsentValidationText,
            attachmentInfo: attachmentInfo,
            inputFileErrorMessage: inputFileErrorMessage,
            instructionSubmit: instructionSubmit,
            instructionMandatory: instructionMandatory,
            instructionEmail: instructionEmail,
        };
        (0, PlusOneForm_1.RenderPlusOneForm)({
            selector: selector,
            apiUrl: apiUrl,
            pageId: pageId,
            control: control,
            formType: formType,
            culture: culture,
            reCaptchaSiteKey: reCaptchaSiteKey,
            formItemsLeft: formItemsLeft,
            formItemsRight: formItemsRight,
            formMessages: formMessages,
            title: title,
            bypassRecaptchaKey: bypassRecaptchaKey,
        });
    };
    return PlusOneComponent;
}(app_1.Component));
exports.PlusOneComponent = PlusOneComponent;
exports.plusOneComponent = new PlusOneComponent();
